import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { getApiUrl } from 'utils/api/apiHelpers'
import { AppWrap } from 'apps/marketplace/components/AppWrap'
import { ShipperRates } from 'apps/rms/components/ShipperRates'
import { RogersRestfulProvider } from 'components/RogersRestfulProvider'
import { logout } from 'utils/userAuth'

export const appName = 'shipper-rates'

export const App = () => (
  <AppWrap appName={appName} title='Rates Management System'>
    <RogersRestfulProvider
      baseApi={`${getApiUrl('MARKETPLACE')}`}
      onUnauthenticatedResponse={logout}>
      <section className='container-fluid'>
        <Switch>
          <Route exact path='/' component={ShipperRates} />
          <Route exact path='/:id' component={ShipperRates} />
        </Switch>
      </section>
    </RogersRestfulProvider>
  </AppWrap>
)
